import { Scale } from "../../../utils/Scale"

export class ShortPos {

    static transparentBoxX = () => Scale.width() * 0.1
    static transparentBoxY = () => 0

    static kidX = () => Scale.width() * 0.49
    static kidY = () => Scale.height() * 0.27

    static momX = () => Scale.width() * 0.24
    static momY = () => Scale.height() * 0.31

    static babyX = () => Scale.width() * 0.65
    static babyY = () => Scale.height() * 0.35

    static dadX = () => Scale.width() * 0.39
    static dadY = () => Scale.height() * 0.37

    static dadSmokeX = () => Scale.width() * 0.51
    static dadSmokeY = () => Scale.height() * 0.41

}
